import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { style: {"height":"30px","text-align":"center"} }
const _hoisted_3 = ["innerHTML"]

import { reactive,  onMounted, computed, watch } from 'vue';

// 入参

export default /*#__PURE__*/_defineComponent({
  __name: 'ShowLargeImage',
  props: {
    imageSrc: null,
    showText: null,
    isShowInput: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    imageSrc:string,
    showText:string,
    isShowInput:boolean,
};



class InitData{
    warpStyle={
        left: '150px'
    }
    imageStyle={
        left:'0px',
        top:'0px'
    }
}
const data = reactive(new InitData());

onMounted(()=>{
    setSite();
})

/**
 * 计算图片的最大显示尺寸
 * @param width 
 * @param height 
 * @param maxWidth 
 * @param maxHeight 
 */
const calWidthAndHeight = (width:number, height:number, maxWidth:number, maxHeight:number):any=>{
    let calWidth = width;
    let calHeight = height;
    if (calHeight >= maxHeight || calWidth >= maxWidth) {
        if (calHeight > maxHeight) { //高度超最大高度,使用最大高度并缩小宽度
            calWidth = calWidth * maxHeight / calHeight;
            calHeight = maxHeight;
        }
        if (calWidth > maxWidth) {//宽度超最大宽度,使用最大宽度并缩小高度
            calHeight = calHeight * maxWidth / calWidth;
            calWidth = maxWidth;
        }
        return {
            calWidth: calWidth,
            calHeight: calHeight
        }
    }
    // 宽度放大
    calHeight = maxWidth * calHeight / calWidth;
    calWidth = maxWidth;
    // 高度放大
    if(calHeight<maxHeight){
        calWidth = maxHeight * calWidth / calHeight;
        calHeight = maxHeight;
    }
    return calWidthAndHeight(calWidth, calHeight, maxWidth, maxHeight);
}

/**
 * 设置图片的尺寸
 * @param imgObj 
 * @param maxWidth 
 * @param maxHeight 
 */
const drawImage = (imgObj:HTMLImageElement, maxWidth:number, maxHeight:number) => {
    var image = new Image();
    image.src = imgObj.src;
    if (image.width > 0 && image.height > 0) {
        let height = image.height;
        let width = image.width;
        let size = calWidthAndHeight(width, height, maxWidth, maxHeight);
        imgObj.width = size.calWidth;
        imgObj.height = size.calHeight;
    }
}

/**
 * 图片导入完成，计算图片的显示位置
 * @param e 
 */
const fastImageLoad = (e: Event)=>{
    setSite();
    let imgObj = e.target as HTMLImageElement;
    let fastShowImage = document.getElementById('fastShowImage');
    let maxWidth = 0;
    let maxHeigth = 0;
    if(fastShowImage){
        maxWidth = fastShowImage.clientWidth-10;
        maxHeigth = fastShowImage.clientHeight-10-30;
    }
    drawImage(imgObj,maxWidth,maxHeigth);

    let imageHeight = imgObj.height;
    let imageWidth = imgObj.width;
    let top = (maxHeigth - imageHeight) / 2;
    let left = (maxWidth - imageWidth) / 2;

    data.imageStyle["left"] = `${left}px`;
    data.imageStyle["top"] = `${top}px`;
}

/**
 * 判定是否显示
 */
const imageShow = computed(()=>{
    if(!props.imageSrc || props.imageSrc.endsWith("null")){
        return false;
    }
    let isShow = props.isShowInput?true:false;
    return isShow
})

/**
 * 设置整个显示层的位置
 */
const setSite=()=>{
    let left = (window.innerWidth-1200)/2+205;
    if(left<205){
        left=205;
    }
    let leftStr = `${left}px`;
    if(leftStr!=data.warpStyle.left){
        data.warpStyle.left = `${left}px`;
    }
}

/**
 * 通过监听isShowInput值，计算设置整个显示层的位置。
 */
watch(()=>props.isShowInput,()=>{
    setSite();
})


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    id: "fastShowImage",
    style: _normalizeStyle(data.warpStyle)
  }, [
    _createElementVNode("img", {
      id: "fastImage",
      alt: "暂无图片",
      src: props.imageSrc,
      onLoad: fastImageLoad,
      style: _normalizeStyle(data.imageStyle)
    }, null, 44, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", {
        innerHTML: props.showText
      }, null, 8, _hoisted_3)
    ])
  ], 4)), [
    [_vShow, _unref(imageShow)]
  ])
}
}

})